import React from 'react';
import { IIcon } from '../../@types/icons';
import { defaultTheme } from './../../styles/theme/default';

export function ChevronLeft ({ onClick, strokeColor = 'white' }: IIcon) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="20"
      fill="none"
      viewBox="0 0 11 20"
      onClick={onClick}
    >
      <g clipPath="url(#clip0_14903_55889)">
        <path
          stroke={defaultTheme.colors[strokeColor]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.432 2.045L1.477 10l7.955 7.954"
        />
      </g>
      <defs>
        <clipPath id="clip0_14903_55889">
          <path
            fill={defaultTheme.colors[strokeColor]}
            d="M0 0H20V11H0z"
            transform="rotate(-90 10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
